import { useMemo } from "react";
import { DUMMY_ASSETS } from "./Avatar.constants";

export const AvatarDummy = ({ index }: { index?: number }) => {
  const randomIndex = useMemo(() => {
    return index ?? Math.floor(Math.random() * DUMMY_ASSETS.length);
  }, [index]);

  if (index !== undefined && index > 16) return null;

  return DUMMY_ASSETS[randomIndex];
};
